export const tipoProducto = {
    Unico: 1,
    Combo: 2
}